<template>
    <div class="ma-5">
        <ValidationObserver ref="observer" v-slot="{ invalid }">
            <v-form @submit.prevent="onSubmit">
                <v-row>
                    <v-col cols="12" md="12">
                        <ValidationProvider rules="required" v-slot="v">
                            <v-autocomplete v-model="selectedItem" dense chips deletable-chips
                                :error-messages="v.errors[0]" :items="haberes" label="Seleccionar periodo" return-object
                                item-value :item-text="item => `${item.rec_descripcion}`"
                                color="primary"></v-autocomplete>
                        </ValidationProvider>
                    </v-col>
                </v-row>
                <v-row class="d-flex flex-row">
                    <v-col cols="12" md="12" class="d-flex justify-end">
                        <v-btn type="onSubmit" class="pa-5" :disabled="invalid" elevation="0" color="primary">
                            <v-icon class="mr-3">mdi-download</v-icon>
                            Descargar
                        </v-btn>
                    </v-col>
                </v-row>
            </v-form>
        </ValidationObserver>
    </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import { ValidationProvider, ValidationObserver } from 'vee-validate';

export default {
    components: {
        ValidationProvider,
        ValidationObserver,
    },
    data() {
        return {
            selectedItem: [],
        }
    },
    mounted() {

    },
    methods: {
        ...mapActions('haberes', ['imprimirPdf', 'getReciboHaberes']),


        onSubmit() {
            this.$refs.observer.validate().then(result => {
                if (result) {
                    this.imprimirPdf({
                        rec_id: this.selectedItem.rec_id,
                        tipo: this.selectedItem.tipo,
                    })
                } else {
                    this.showSnack({
                        message: 'Formulario inválido, no se puede enviar la petición',
                        type: '400'
                    })
                }
            });
        },
    },
    computed: {
        ...mapGetters('haberes', ['haberes']),
        ...mapGetters('auth', ['nroafi'])
    }
};
</script>